import type {
  AnalyticsApi as CoreAnalyticsApi,
  AnalyticsEvent as CoreAnalyticsEvent,
} from '@backstage/core-plugin-api';

export class CombinedAnalyticsApi implements CoreAnalyticsApi {
  private constructor(private readonly apis: CoreAnalyticsApi[]) {}
  static fromApis(apis: CoreAnalyticsApi[]) {
    return new CombinedAnalyticsApi(apis);
  }
  captureEvent(event: CoreAnalyticsEvent) {
    this.apis.forEach(a => {
      try {
        a.captureEvent(event);
      } catch {
        // Ignore individual provider errors to ensure all providers are attempted
      }
    });
  }
}
